/**
 * useMobileRedirect · v2.6.9 batch BQ/BZ
 * ====================================
 * Smartphones (viewport width < 768 px, i.e. smaller than iPad portrait)
 * landing on a marketing route can be auto-redirected to the rider booking
 * flow. Gated by the global `mobile_redirect_enabled` CMS toggle which
 * DEFAULTS TO FALSE — admins must explicitly opt-in. Critically we wait
 * for the CMS config to actually load before deciding so we don't ship a
 * race-condition redirect when localStorage is empty and the config fetch
 * hasn't resolved yet (was the v2.6.9 batch BZ tester-found bug).
 */
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useSiteConfig from "@/hooks/useSiteConfig";

const MOBILE_MAX_WIDTH_PX = 768; // iPad portrait threshold

export default function useMobileRedirect() {
  const nav = useNavigate();
  const loc = useLocation();
  const { cfg, loading } = useSiteConfig();
  // v2.6.9 batch BZ · Strict opt-in only. If config is still loading OR the
  // flag is anything other than literally `true`, skip the redirect.
  const enabled = !!(cfg?.global?.mobile_redirect_enabled === true);

  useEffect(() => {
    if (loading || !enabled) return;
    // Skip if the user is already inside the rider, driver, or admin app.
    if (loc.pathname.startsWith("/ride") || loc.pathname.startsWith("/admin") || loc.pathname.startsWith("/login") || loc.pathname.startsWith("/dashboard")) {
      return;
    }
    const check = () => {
      if (typeof window === "undefined") return;
      if (window.innerWidth < MOBILE_MAX_WIDTH_PX) {
        nav("/ride/login", { replace: true });
      }
    };
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [enabled, loading, loc.pathname, nav]);
}
